import { useEffect, useState } from "react";

const VerifyAadhaar = () => {
	console.log("Aadhaar Verification Redirect Loaded");

	const [result, setResult] = useState("UNKNOWN");
	const [countdown, setCountdown] = useState(5);
	const [shouldShowFallback, setShouldShowFallback] = useState(false);

	useEffect(() => {
		const params = new URLSearchParams(window.location.search);

		const action = params.get("action");
		const status = params.get("status");
		const verification = params.get("verification_status");

		let computed = "UNKNOWN";

		if (action === "success" || status === "success" || verification === "verified") {
			computed = "SUCCESS";
		} else if (action === "consent-denied") {
			computed = "CONSENT_DENIED";
		} else if (action === "failed" || status === "failed" || verification === "failed") {
			computed = "FAILED";
		} else if (action === "error") {
			computed = "ERROR";
		}

		setResult(computed);

		// Send message to opener
		try {
			if (window.opener && !window.opener.closed) {
				window.opener.postMessage(
					{
						type: "AADHAAR_KYC_RESULT",
						result: computed
					},
					window.location.origin
				);
			}
		} catch (e) {
			console.error("postMessage failed:", e);
		}

		// Start countdown
		const timer = setInterval(() => {
			setCountdown(prev => {
				if (prev === 1) {
					clearInterval(timer);

					// Try to close after countdown
					window.close();

					// If blocked → show fallback
					setTimeout(() => {
						if (!window.closed) {
							setShouldShowFallback(true);
						}
					}, 300);
				}
				return prev - 1;
			});
		}, 1000);

		return () => clearInterval(timer);
	}, []);

	// Fallback UI if window.close() is blocked
	if (shouldShowFallback) {
		return (
			<div style={styles.wrapper}>
				<h2>Redirecting back to KonfHub</h2>
				<p>You can now close this tab and return to KonfHub.</p>
			</div>
		);
	}

	// Countdown UI
	return (
		<div style={styles.wrapper}>
			<h2>Redirecting back to KonfHub</h2>
			<p>
				This window will close automatically in <strong>{countdown}</strong> seconds…
			</p>
			<p>You can also close it manually.</p>
		</div>
	);
};

const styles = {
	wrapper: {
		height: "100vh",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		fontFamily: "sans-serif",
		textAlign: "center",
		padding: "20px"
	}
};

export default VerifyAadhaar;
